import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-audit-life-cycle',
  templateUrl: './audit-life-cycle.component.html',
  styleUrls: ['./audit-life-cycle.component.scss']
})
export class AuditLifeCycleComponent implements OnInit {
  @Input() auditLifeCycleList: any;
  @Input() boxType: string = 'phase';
  constructor() { }

  ngOnInit(): void {
  }

}
